var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchPlaceholderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4 1.6C3.74903 1.6 1.6 3.74903 1.6 6.4C1.6 9.05097 3.74903 11.2 6.4 11.2C9.05097 11.2 11.2 9.05097 11.2 6.4C11.2 3.74903 9.05097 1.6 6.4 1.6ZM0 6.4C0 2.86538 2.86538 0 6.4 0C9.93462 0 12.8 2.86538 12.8 6.4C12.8 9.93462 9.93462 12.8 6.4 12.8C2.86538 12.8 0 9.93462 0 6.4Z",
    fill: "#D1D5DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83432 9.83432C10.1467 9.5219 10.6533 9.5219 10.9657 9.83432L15.7657 14.6343C16.0781 14.9467 16.0781 15.4533 15.7657 15.7657C15.4533 16.0781 14.9467 16.0781 14.6343 15.7657L9.83432 10.9657C9.5219 10.6533 9.5219 10.1467 9.83432 9.83432Z",
    fill: "#D1D5DB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchPlaceholderIcon);
export default __webpack_public_path__ + "static/media/SearchPlaceholderIcon.ca42e1f2.svg";
export { ForwardRef as ReactComponent };